import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import createOidcMiddleware from 'redux-oidc';
import { rootReducer } from '../reducers/rootReducer';
import { startSaga } from '../sagas';
import userManager from '../oidc/userManager';

const sagaMiddleware = createSagaMiddleware();
const oidcMiddleware = createOidcMiddleware(userManager);

const middlewares = [
  oidcMiddleware,
  sagaMiddleware,
];

const composeEnhancers =
  typeof window === 'object' &&
  // @ts-ignore
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?   window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(...middlewares),
  // other store enhancers if any
);

const store = createStore(
  rootReducer,
  enhancer,
);

sagaMiddleware.run(startSaga);

export default store;
